// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__1EkJQ","content":"Consent_content__1kLfg","footer":"Consent_footer__3jRQi"};